import {useEffect, useRef} from 'react';
import useTypedSelector from '../../common/hook/useTypedSelector';
import {ZIndex} from '../../common/scss/util/variable';

export default function useWaterMark() {
  const user = useTypedSelector(state => state.auth.user);
  const animationFrameHandleRef = useRef(0);
  useEffect(() => {
    function checkAndAddWaterMark() {
      if (!document.getElementById(CONTAINER_ID)) {
        const userId = user ? user.id : KAKAOPAGE;
        const container = document.createElement('div');
        container.id = CONTAINER_ID;
        // 같은 곳에 계속 노출하면 글자가 보이는 효과(burn-in 효과)가 있다고 해서 top을 랜덤으로 지정
        const top = Math.random() * 50;
        container.style.cssText = `position:fixed; left:0; top:${top}px; bottom:0; width:100%; opacity:0.002; display:flex; flex-direction:column; justify-content:space-between; font-size:14px; z-index:${ZIndex.WaterMark}; pointer-events: none;`;
        for (let i = 0; i < 10; i++) {
          const div = document.createElement('div');
          div.style.cssText =
            'width:100%; display:flex; justify-content:space-between;';
          for (let k = 0; k < 3; k++) {
            const span = document.createElement('span');
            span.style.cssText =
              'color:' + (k === 0 ? 'red' : k === 1 ? 'green' : 'blue');
            // 한줄에 userId를 한 번 노출
            span.textContent = (i + k) % 3 === 0 ? userId : KAKAOPAGE;
            div.appendChild(span);
          }
          container.appendChild(div);
        }

        document.body.appendChild(container);
      }
      animationFrameHandleRef.current =
        requestAnimationFrame(checkAndAddWaterMark);
    }

    const prevContainer = document.getElementById(CONTAINER_ID);
    if (prevContainer) {
      cancelAnimationFrame(animationFrameHandleRef.current);
      document.body.removeChild(prevContainer);
    }
    animationFrameHandleRef.current =
      requestAnimationFrame(checkAndAddWaterMark);
    return () => {
      cancelAnimationFrame(animationFrameHandleRef.current);
    };
  }, [user]);
}

const CONTAINER_ID = 'kw-marker';
const KAKAOPAGE = 'gkakaowebtoon';
